module.exports = __webpack_public_path__ + "fonts/iconfont.b49ba38.woff2";